module.exports = __webpack_public_path__ + "media/customizations/cypressgreenlife/logo-new-1a0262eb80fa85f71789702b5add43ee.png";